/**
 * @module utils/array
 */

/**
 * @typedef {array} Array
 */

/**
 * Merges any number of arrays to a frozen one
 * @param {...*} arrays
 * @returns {Array}
 */
export default (
    ...arrays
) => {
  const clone = arrays.flat()

  Object.freeze(clone)

  return clone
}
